import { MatLegacyPaginatorIntl as MatPaginatorIntl } from '@angular/material/legacy-paginator';
import { TranslateService } from '@ngx-translate/core';
const RangeLabel = (page: number, pageSize: number, length: number) => {
  if (length === 0 || pageSize === 0) { return `0 of ${length}`; }

  length = Math.max(length, 0);

  const startIndex = page * pageSize;
  const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} of ${length}`;
};


export function getPaginatorIntl(translate: TranslateService) {
  const paginatorIntl = new MatPaginatorIntl();
  translate.get('paginator').subscribe(_text => {
     paginatorIntl.itemsPerPageLabel = _text['size'];
     paginatorIntl.firstPageLabel = _text['first'];
     paginatorIntl.nextPageLabel = _text['next'];
     paginatorIntl.previousPageLabel = _text['prev'];
     paginatorIntl.lastPageLabel = _text['last'];
  });
  paginatorIntl.getRangeLabel = RangeLabel;

  return paginatorIntl;
}
